<template>
  <div class="featured-brands">
    <ul>
      <li v-for="(brand, index) in featuredBrands" :key="index">
        <a :class="{ 'active': brand.active }" href="" @click.prevent="selectBrand(brand)">
          <img :src="brand.logo" :alt="brand.name">
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'FeaturedBrands',
  props: {
    payload: Object
  },
  computed: {
    ...mapState({
      brands: state => state.brands.items
    }),
    featuredBrands () {
      const brands = []

      this.brands.forEach((brand) => {
        if(brand.featured) {
          brands.push(brand)
        }
      })

      brands.forEach((brand, index) => {
        brands[index].active = this.payload.brands.includes(brand.id);
      })

      return brands
    }
  },
  methods: {
    selectBrand (brand) {
      if(!this.payload.brands.includes(brand.id)) {
        const newPayload = this.payload
        newPayload.brands.push(brand.id)
        this.$emit('update', newPayload)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.featured-brands{
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: span 2;

  @include responsive(mobile) {
    display: none;
  }

  ul{
    width: auto;
    text-align: center;

    li{
      width: auto;
      margin: 0 10px;

      a{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        overflow: hidden;
        padding: 10px;
        border: 2px solid darken($white, 5%);
        @include radius(100%);
        @include transition();

        &:hover{
          border: 2px solid $black;
        }

        &.active, &.active:hover{
          border: 2px solid $primary;
        }

        img{
          max-width: 100%;
          max-height: 60%;
          width: auto;
          height: auto;
        }
      }
    }
  }
}
</style>
